// Some shared styles used by nav bar buttons.

import styled from 'astroturf/react';
import _IconAnchor from "styles-IconAnchor.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/nav_buttons/styles.ts?styleId=IconAnchor";
import _IconButton from "styles-IconButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/nav_buttons/styles.ts?styleId=IconButton";
import _IconContainer from "styles-IconContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/nav_buttons/styles.ts?styleId=IconContainer";
import _IconLabel from "styles-IconLabel.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/nav_buttons/styles.ts?styleId=IconLabel";


export const IconAnchor = /*#__PURE__*/styled("a", null, {
  displayName: "IconAnchor",
  styles: _IconAnchor
});

export const IconButton = /*#__PURE__*/styled("button", null, {
  displayName: "IconButton",
  styles: _IconButton
});

export const IconContainer = /*#__PURE__*/styled("div", null, {
  displayName: "IconContainer",
  styles: _IconContainer
});

export const IconLabel = /*#__PURE__*/styled("div", null, {
  displayName: "IconLabel",
  styles: _IconLabel
});
